import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { IonModal, IonContent, IonHeader, IonSlides, IonSlide } from '@ionic/react'
import { getPercent, getCouponsInfo } from '@utils'
import MemberCardApi from '@api/memberCard.api'
import { format, toPrice } from '@dt/fe-utils'
import ActivityApi from '@api/activity.api'
import { keyBy, map, findIndex } from '@dt/fe-utils/dist/lodash'
import { CardIntegralEquity } from '@cps'
import './index.scss'

import cardBg from '@img/member/card-bg.png'

interface IProps {
  cardInfo: any;
  reject?: () => void;
  resolve?: (path: string) => void;
}

const CardLevelModal: FC<IProps> = (props) => {
  const { cardInfo, reject, resolve } = props
  const [levelInfo, setLevelInfo] = useState<any[]>([])
  const [levelIndex, setLevelIndex] = useState<number>(0)
  const [themeColor, setThemeColor] = useState<string>('#161616')
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [timeCoupon, setTimeCoupon] = useState<any>({})
  const initOpts = {
    initialSlide: levelIndex,
    autoplay: false,
    loop: false,
    on: {
      slideChange () {
        const swiper = this as any
        setLevelIndex(swiper.activeIndex)
        setThemeColor(getThemeColor(levelInfo[swiper.activeIndex]))
        getCurCoupons(swiper.activeIndex)
      }
    }
  }
  const getThemeColor = (info: any) => {
    let color: string = '#161616'
    if (info?.extra?.themeColor) {
      color = info.extra.themeColor
    } else if (!info?.extra?.fontColor) {
      color = levelInfo[0].extra?.themeColor || '#161616'
    }
    return color
  }
  const getCoupDetail = (coupons: any[]) => {
    const list: any[] = []
    map(coupons, (i: any) => {
      if (couponDetails[i.couponId]) list.push(`${couponDetails[i.couponId].couponName} (${i18n.t('mkt.coupon.couponNum', { cnt: i.couponCnt })})`)
    })
    return list
  }
  const getCurCoupons = (index: number, defaultLevelInfo?: any) => {
    const curLevelInfo = defaultLevelInfo || levelInfo
    if (curLevelInfo[index]) {
      let coupons: any = []
      const timeInfo = curLevelInfo[index]?.couponPolicys ? curLevelInfo[index].couponPolicys.filter(item => item.sendType === 'time') : []
      if (timeInfo.length) {
        setTimeCoupon(timeInfo[0])
        timeInfo.map((item: any) => {
          coupons = coupons.concat(item.coupons)
        })
      } else {
        setTimeCoupon({})
      }
      const recharges = curLevelInfo[index]?.recharges?.length ? curLevelInfo[index].recharges : curLevelInfo[0].allowAgainLoad ? curLevelInfo[0].recharges : []
      const rechargeInfo = recharges.filter(item => item.coupons.length) || []
      if (rechargeInfo.length) {
        rechargeInfo.map((item: any) => {
          coupons = coupons.concat(item.coupons)
        })
      }
      if (coupons.length > 0) {
        ActivityApi.getCouponsList({ couponIds: getCouponsInfo(coupons) }).then((res: any) => {
          if (res?.length > 0) {
            setCouponDetails(keyBy(res, 'couponId'))
          }
        })
      }
    }
  }
  // Component Effect
  useEffect(() => {
    MemberCardApi.getLevelCardList(cardInfo.cardId).then((res: any) => {
      if (!res.error) {
        if (res.length > 1 || res[0].isLevel) {
          const curIndex = findIndex(res, (item: any) => item.cardId === cardInfo.card?.cardId) || 0
          setLevelInfo(res)
          setThemeColor(res[0]?.extra?.themeColor || '#161616')
          setLevelIndex(curIndex)
          if (curIndex === 0) getCurCoupons(curIndex, res)
        } else {
          setLevelInfo([])
          setLevelIndex(0)
          getCurCoupons(0)
        }
      }
    })
  }, [])
  // useEffect(() => {
  //   if (levelInfo[levelIndex]) {
  //     let coupons: any = []
  //     const timeInfo = levelInfo[levelIndex]?.couponPolicys ? levelInfo[levelIndex].couponPolicys.filter(item => item.sendType === 'time') : []
  //     if (timeInfo.length) {
  //       setTimeCoupon(timeInfo[0])
  //       timeInfo.map((item: any) => {
  //         coupons = coupons.concat(item.coupons)
  //       })
  //     } else {
  //       setTimeCoupon({})
  //     }
  //     const recharges = levelInfo[levelIndex]?.recharges?.length ? levelInfo[levelIndex].recharges : levelInfo[0].allowAgainLoad ? levelInfo[0].recharges : []
  //     const rechargeInfo = recharges.filter(item => item.coupons.length) || []
  //     if (rechargeInfo.length) {
  //       rechargeInfo.map((item: any) => {
  //         coupons = coupons.concat(item.coupons)
  //       })
  //     }
  //     if (coupons.length > 0) {
  //       ActivityApi.getCouponsList({ couponIds: getCouponsInfo(coupons) }).then((res: any) => {
  //         if (res?.length > 0) {
  //           setCouponDetails(keyBy(res, 'couponId'))
  //         }
  //       })
  //     }
  //   }
  // }, [levelInfo[levelIndex]])
  return (
    <IonModal
      cssClass='card-level-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.member.levelDetails')}</span>
        <i data-cypid='clickHeaderBack' className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        {
          cardInfo && !!levelInfo.length &&
            <div className='modal-body'>
              <IonSlides className='card-slides' options={initOpts} id='slidesTag'>
                {
                  levelInfo.map((item: any, index: number) => {
                    let cardCover: string = cardBg
                    if (item.cover) {
                      cardCover = item.cover
                    } else if (!item?.extra?.fontColor) {
                      cardCover = levelInfo[0].cover || cardBg
                    }
                    return (
                      <IonSlide key={item.cardId}>
                        <div className='card-slides-item' style={{ backgroundImage: `url(${cardCover})` }}>
                          <div className='item-title' style={{ color: item.extra.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}><span className='card-level'>LV{index + 1}</span><span className='card-name'>{item.cardName}</span></div>
                          {
                            index < levelInfo.length - 1 &&
                              <>
                                <div className='pro-bar' style={{ color: item.extra.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}>
                                  <div className='pro-bar-left'>Lv{index + 1}</div>
                                  <div className='pro-bar-right'>Lv{index + 2}</div>
                                  <div className='pro-bar-bg'></div>
                                  <div className='pro-bar-completed' style={{ backgroundColor: item.extra.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8', width: cardInfo.growth >= levelInfo[index + 1].levelGrowth ? '100%' : `${getPercent(cardInfo.growth - item.levelGrowth, levelInfo[index + 1].levelGrowth - item.levelGrowth) || 0}%` }}></div>
                                </div>
                                <div className='item-text' style={{ color: item.extra.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}>{i18n.t('mkt.member.growthValue')}{cardInfo.growth}/{levelInfo[index + 1].levelGrowth}</div>
                              </>
                          }
                        </div>
                      </IonSlide>)
                  })
                }
              </IonSlides>
              <div className='level-count-bar'>
                <div className='level-count-bar-ed' style={{ transform: `translateX(${levelIndex * -18}%)` }}>
                  {
                    levelInfo.map((item: any, index: number) => {
                      return (
                        <div key={item.cardId} className='colorful-item' style={{ width: `${index === 0 ? 50 : 18}%`, left: `${index === 0 ? 0 : 18 * index + 50}%` }}>
                          <div className='colorful-block'>
                            <div className='colorful-item-ed' style={{ width: cardInfo.growth >= levelInfo[index].levelGrowth ? '100%' : `${cardInfo.growth - levelInfo[index - 1].levelGrowth > 0 ? getPercent(cardInfo.growth - levelInfo[index - 1].levelGrowth, item.levelGrowth - levelInfo[index - 1].levelGrowth) : 0}%`, backgroundColor: getThemeColor(item) }}></div>
                            {
                              index === levelIndex
                                ? <div className='colorful-center-block'><div className='colorful-point-center' style={{ backgroundColor: cardInfo.card.level >= index + 1 ? getThemeColor(item) : '#9d9d9d' }}></div></div>
                                : <div className='colorful-point' style={{ backgroundColor: cardInfo.card.level >= index + 1 ? getThemeColor(item) : '#9d9d9d' }}></div>
                            }
                            {index > 0 && <div className='colorful-point-num'><span className={`text${index === levelIndex + 1 ? ' center-text' : ''}`}>Lv{index}</span></div>}
                          </div>
                        </div>
                      )
                    })
                  }
                  <div className='colorful-item' style={{ width: '50%', backgroundColor: cardInfo.card.level === levelInfo.length ? getThemeColor(levelInfo[levelInfo.length - 1]) : '#c4c4c4', left: `${18 * levelInfo.length + 50}%` }}>
                    <div className='colorful-block'>
                      <div className='colorful-item-ed'></div>
                      <div className='colorful-point-num'><span className={`text${levelInfo.length - 1 === levelIndex ? ' center-text' : ''}`}>Lv{levelInfo.length}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              {
                !!levelInfo.length && levelInfo[levelIndex] &&
                  <div className='cur-level-info'>
                    {
                      (!!levelInfo[levelIndex].discountType || !!levelInfo[levelIndex]?.recharges?.length || !!levelInfo[0].allowAgainLoad || !!levelInfo[levelIndex].integralMoney || !!timeCoupon?.sendType || !!levelInfo[levelIndex].mallDiscountType) &&
                        <div className='cur-level-info-title'>{i18n.t('mkt.member.levelPrivilege')}</div>
                    }
                    <div className='cur-level-benefit'>
                      {
                        !!levelInfo[levelIndex].discountType &&
                          <div className='cur-level-benefit-block'>
                            <div className='cur-level-benefit-icon' style={{ backgroundColor: themeColor }}><i className='iconfont icon-mealsnew1' style={{ color: levelInfo[levelIndex].extra?.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}></i></div>
                            <div className='cur-level-benefit-text'>{i18n.t('mkt.member.mealBenefit')}</div>
                          </div>
                      }
                      {
                        (!!levelInfo[levelIndex]?.recharges?.length || !!levelInfo[0].allowAgainLoad) &&
                          <div className='cur-level-benefit-block'>
                            <div className='cur-level-benefit-icon' style={{ backgroundColor: themeColor }}><i className='iconfont icon-shangchengicon2' style={{ color: levelInfo[levelIndex].extra?.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}></i></div>
                            <div className='cur-level-benefit-text'>{i18n.t('mkt.member.rechargeBenefit')}</div>
                          </div>
                      }
                      {
                        (!!levelInfo[levelIndex].isIntegralMoney || !!levelInfo[levelIndex].isIntegral) &&
                          <div className='cur-level-benefit-block'>
                            <div className='cur-level-benefit-icon' style={{ backgroundColor: themeColor }}><i className='iconfont icon-jifen1' style={{ color: levelInfo[levelIndex].extra?.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}></i></div>
                            <div className='cur-level-benefit-text'>{i18n.t('mkt.member.integralGet')}</div>
                          </div>
                      }
                      {
                        !!timeCoupon?.sendType &&
                          <div className='cur-level-benefit-block'>
                            <div className='cur-level-benefit-icon' style={{ backgroundColor: themeColor }}><i className='iconfont icon-entry-newgroupBuy0' style={{ color: levelInfo[levelIndex].extra?.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}></i></div>
                            <div className='cur-level-benefit-text'>{i18n.t('mkt.member.couponSend')}</div>
                          </div>
                      }
                      {
                        !!levelInfo[levelIndex].mallDiscountType &&
                          <div className='cur-level-benefit-block'>
                            <div className='cur-level-benefit-icon' style={{ backgroundColor: themeColor }}><i className='iconfont icon-shangchengicon3' style={{ color: levelInfo[levelIndex].extra?.fontColor || levelInfo[0].extra?.fontColor || '#B8B8B8' }}></i></div>
                            <div className='cur-level-benefit-text'>{i18n.t('mkt.member.mallBenefit')}</div>
                          </div>
                      }
                    </div>
                    {
                      !!levelInfo[levelIndex].discountType &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.mealBenefit')}</div>
                          <div className='cur-level-info-text'>
                            {cardInfo.card?.products?.length ? i18n.t('mkt.member.someMealConsumeGet') : i18n.t('mkt.member.mealConsumeGet')}: {levelInfo[levelIndex].discountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', levelInfo[levelIndex].discountValue)}
                          </div>
                        </>
                    }
                    {
                      (!!levelInfo[levelIndex]?.recharges?.length || !!levelInfo[0].allowAgainLoad) &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.rechargeBenefit')}</div>
                          <div className='cur-level-info-text'>
                            {
                              levelInfo[levelInfo[levelIndex]?.recharges?.length ? levelIndex : 0].recharges.map((item: any) => (
                                <div key={item.cardRechargeId}>
                                  <span>{i18n.t('order.charge', { price: toPrice(item.money) })}</span>
                                  {!!item.moneyGive && <span>{i18n.t('mkt.giftCard.giveAway')} {toPrice(item.moneyGive)}</span>}
                                  {!!item?.coupons?.length && <span>{i18n.t('newCart.given')} {getCoupDetail(item.coupons).join(',')}</span>}
                                </div>
                              ))
                            }
                          </div>
                        </>
                    }
                    {
                      (!!levelInfo[levelIndex].isIntegral) &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.integralGet')}</div>
                          <div className='cur-level-info-text'>
                            <CardIntegralEquity cardInfo={levelInfo[levelIndex]} showClearTip={false} />
                          </div>
                        </>
                    }
                    {
                      !!timeCoupon?.sendType &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.couponSend')}</div>
                          <div className='cur-level-info-text'>
                            <span>{i18n.t(`mkt.member.sendTime${timeCoupon.sendValue}`)}:</span>
                            <span>{getCoupDetail(timeCoupon.coupons).join(',')}</span>
                          </div>
                        </>
                    }
                    {
                      !!levelInfo[levelIndex].mallDiscountType &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.mallBenefit')}</div>
                          <div className='cur-level-info-text'>
                            {levelInfo[levelIndex]?.mallProducts?.length ? i18n.t('mkt.member.someMallConsumeGet') : i18n.t('mkt.member.mallConsumeGet')}: {levelInfo[levelIndex].mallDiscountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', levelInfo[levelIndex].mallDiscountValue)}
                          </div>
                        </>
                    }
                    {
                      (!!levelInfo[levelIndex].mallGrowthGet || !!levelInfo[levelIndex].consumeGrowthGet || !!levelInfo[levelIndex].rechargeGrowthGet) &&
                        <>
                          <div className='cur-level-info-title'>{i18n.t('mkt.member.growthValueGet')}</div>
                          <div className='cur-level-info-text'>
                            <div>{!!levelInfo[levelIndex].mallGrowthGet && i18n.t('mkt.member.mallConsumeGrowth2', { amount: toPrice(levelInfo[levelIndex].mallGrowth), num: levelInfo[levelIndex].mallGrowthGet })}</div>
                            <div>{!!levelInfo[levelIndex].consumeGrowthGet && i18n.t('mkt.member.mealConsumeGrowth2', { amount: toPrice(levelInfo[levelIndex].consumeGrowth), num: levelInfo[levelIndex].consumeGrowthGet })}</div>
                            <div>{!!levelInfo[levelIndex].rechargeGrowthGet && i18n.t('mkt.member.mealRecharge2', { amount: toPrice(levelInfo[levelIndex].rechargeGrowth), num: levelInfo[levelIndex].rechargeGrowthGet })}</div>
                          </div>
                        </>
                    }
                  </div>
              }
              {/* <div className='mkt-detail-area'>
                {
                  !!levelInfo.length &&
                    <>
                      {
                        (cardInfo.card?.nextLevelInfo || cardInfo.card?.level > 1) &&
                          <div className='levelinfo-value'>
                            <div>
                              <span>{cardInfo.card?.nextLevelInfo ? i18n.t('mkt.member.upgradePoi', { growth: cardInfo.card.nextLevelInfo.levelGrowth - cardInfo.growth }) : i18n.t('mkt.member.highestGrade')}</span>
                              <span className='level-num'>LV{cardInfo.card?.nextLevelInfo ? cardInfo.card.level + 1 : cardInfo.card.level}</span>
                            </div>
                            <div className='pro-bar'>
                              <div className='pro-bar-bg'></div>
                              <div style={{ width: cardInfo.card.nextLevelInfo ? `${getPercent(cardInfo.growth, cardInfo.card.nextLevelInfo.levelGrowth) || 0}%` : '100%' }} className='pro-bar-completed'></div>
                            </div>
                            <div className='cur-growth-value'>{i18n.t('mkt.member.curGrowthValue')} {cardInfo.growth}</div>
                          </div>
                      }
                      <div className='card-info-block'>
                        <div className='title'>{i18n.t('mkt.member.levelCardTit')}</div>
                        <div className='des'>
                          <LevelTable levelInfo={levelInfo}></LevelTable>
                        </div>
                      </div>
                    </>
                }
              </div> */}
            </div>
        }
      </IonContent>
    </IonModal>
  )
}

export default observer(CardLevelModal)
